module.exports = __webpack_public_path__ + "img/people.55c38dbd.svg";